import { render, staticRenderFns } from "./StylesEditor.vue?vue&type=template&id=e94710de&"
import script from "./StylesEditor.vue?vue&type=script&lang=js&"
export * from "./StylesEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e94710de')) {
      api.createRecord('e94710de', component.options)
    } else {
      api.reload('e94710de', component.options)
    }
    module.hot.accept("./StylesEditor.vue?vue&type=template&id=e94710de&", function () {
      api.rerender('e94710de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/theme/components/StylesEditor.vue"
export default component.exports